(() => {
  const initialize = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const media = window.matchMedia('(min-width: 750px)');
    const groups = [...root.querySelectorAll('.tb-footer__group')];
    const sync = () => {
      groups.forEach((group) => {
        group.open = media.matches;
        const summary = group.querySelector('summary');
        if (media.matches) summary.setAttribute('tabindex', '-1');
        else summary.removeAttribute('tabindex');
      });
    };
    groups.forEach((group) => {
      group.querySelector('summary').addEventListener('click', (event) => {
        if (media.matches) event.preventDefault();
      });
    });
    media.addEventListener('change', sync);
    sync();
  };
  document.querySelectorAll('[data-tb-footer]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-tb-footer]').forEach(initialize);
  });
})();
